/* eslint-disable react-hooks/exhaustive-deps */
import { graphql, Link, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';
import '../styles/global.scss';
import LetsTalk from './LetsTalk';

const Navbar = ({ isCareer, isWithoutHero }) => {
  const data = useStaticQuery(graphql`
    {
      contentfulAsset(file: { fileName: { eq: "Nuclei-Logo-White.svg" } }) {
        file {
          url
        }
      }
      site {
        siteMetadata {
          title
        }
      }
      contentfulNavbar {
        products
        about
      }
      allContentfulProduct {
        nodes {
          name
          slug
        }
      }
    }
  `);
  let listener = null;
  const [isActive, setActive] = useState('');
  const [isModal, setModal] = React.useState({ active: false, content: '' });
  const [scrollState, setScrollState] = useState(false);
  React.useEffect(() => {
    listener = document.addEventListener('scroll', () => {
      var scrolled = document.scrollingElement.scrollTop;
      if (scrolled >= 50) {
        if (scrollState !== 'scrolled') {
          setScrollState(true);
        }
      } else {
        if (scrollState !== 'top') {
          setScrollState(false);
        }
      }
    });
    return () => {
      document.removeEventListener('scroll', listener);
    };
  }, [scrollState]);

  return (
    <nav
      className='navbar is-custom is-fixed-top is-transparent'
      style={
        isActive || scrollState || isCareer || isWithoutHero
          ? {
              background: '#002e4a',
              maxWidth: '100vw',
              transition: 'all 0.4s ease',
            }
          : {
              background: 'transparent',
              maxWidth: '100vw',
              transition: ' all 0.4s ease',
            }
      }
    >
      <div className='navbar-brand'>
        <Link className='' to='/'>
          <img
            src={data.contentfulAsset.file.url}
            alt={data.site.siteMetadata.title}
            style={{ marginBottom: 10 }}
            className='logo-nav'
            loading='eager'
          />
        </Link>

        <div
          role='button'
          class={`burger navbar-burger ${isActive}`}
          data-target='navMenu'
          aria-label='menu'
          aria-expanded='false'
          style={{ color: '#fff', marginTop: '10px' }}
          onClick={() =>
            isActive === 'is-active'
              ? setActive('is-clipped')
              : setActive('is-active')
          }
        >
          <span aria-hidden='true' />
          <span aria-hidden='true' style={{ width: '14%' }} />
          <span aria-hidden='true' />
        </div>
      </div>
      <div
        className={`navbar-menu ${isActive}`}
        style={
          isActive || scrollState
            ? {
                background: '#002e4a',
                transition: ' all 0.4s ease',
              }
            : { background: 'transparent', transition: ' all 0.4s ease' }
        }
      >
        <div className='navbar-start'>
          <div className='navbar-item has-dropdown is-hoverable '>
            <Link
              activeClassName='active'
              to={`/product/${data.allContentfulProduct.nodes[0].slug}`}
              className='navbar-link navbar-top-text'
              style={{
                paddingRight: '40px',
                transition: '0.4s ease',
                textDecoration: 'none',
              }}
            >
              Products
            </Link>
            <div class='navbar-dropdown'>
              {Object.keys(data.allContentfulProduct.nodes).map(i => {
                return (
                  <Link
                    activeClassName='active'
                    to={`/product/${data.allContentfulProduct.nodes[i].slug}`}
                    className='navbar-item'
                    style={{ paddingRight: '40px', transition: '0.4s ease' }}
                  >
                    {data.allContentfulProduct.nodes[i].name}
                  </Link>
                );
              })}
            </div>
          </div>
          <div className='navbar-item has-dropdown is-hoverable '>
            <Link
              activeClassName='active'
              to={`/about`}
              className='navbar-link navbar-top-text'
              style={{
                paddingRight: '40px',
                transition: '0.4s ease',
                textDecoration: 'none',
              }}
            >
              About Us
            </Link>
            <div class='navbar-dropdown'>
              <Link
                activeClassName='active'
                to={`/about`}
                className='navbar-item'
                style={{ paddingRight: '40px', transition: '0.4s ease' }}
              >
                Our Story
              </Link>
              <Link
                activeClassName='active'
                to={`/media`}
                className='navbar-item'
                style={{ paddingRight: '40px', transition: '0.4s ease' }}
              >
                Media Mentions
              </Link>
              <Link
                activeClassName='active'
                to={`/corporate-governance`}
                className='navbar-item'
                style={{ paddingRight: '40px', transition: '0.4s ease' }}
              >
                Corporate Governance
              </Link>
            </div>
          </div>
          <Link
            activeClassName='active'
            to='/tech-stack'
            className='navbar-item navbar-top-text'
            style={{
              paddingRight: '20px',
              transition: '0.4s ease',
            }}
          >
            Tech Stack
          </Link>
          <Link
            activeClassName='active'
            to='/handbook'
            className='navbar-item navbar-top-text'
            style={{
              paddingRight: '20px',
              transition: '0.4s ease',
            }}
          >
            Employee Handbook
          </Link>
          <Link
            className='navbar-item navbar-top-text'
            activeClassName='active'
            to='/careers'
            style={{ paddingRight: '20px', transition: '0.4s ease' }}
          >
            Careers
          </Link>
          <div className='navbar-item has-dropdown is-hoverable '>
            <Link
              activeClassName='active'
              to={`/resources`}
              className='navbar-link navbar-top-text'
              style={{
                paddingRight: '40px',
                transition: '0.4s ease',
                textDecoration: 'none',
              }}
            >
              Resources
            </Link>
            <div class='navbar-dropdown'>
              <Link
                activeClassName='active'
                to={`/resources`}
                className='navbar-item'
                style={{ paddingRight: '40px', transition: '0.4s ease' }}
              >
                Blogs
              </Link>
              <Link
                activeClassName='active'
                to={`/podcast`}
                className='navbar-item'
                style={{ paddingRight: '40px', transition: '0.4s ease' }}
              >
                Podcasts
              </Link>
            </div>
          </div>
        </div>
        <div className='navbar-end'>
          <div className='navbar-item' style={{ paddingTop: 0 }}>
            <div className='field is-grouped'>
              <p className='control navbar-button'>
                <div
                  className='button '
                  onClick={() => {
                    setActive('is-clipped');
                    setModal({ content: 'is-active', active: true });
                  }}
                >
                  <span className='button-text'>Interested?</span>
                </div>
              </p>
            </div>
          </div>
        </div>
      </div>
      {isModal.active && <LetsTalk active={isModal} setModal={setModal} />}
    </nav>
  );
};

Navbar.defaultProps = {
  isCareer: true,
};

export default Navbar;
